export class StringUtil {
    static date2Object(date: Date) {
        if (date) {
            let y = date.getFullYear();
            let m = date.getMonth() + 1;
            let d = date.getDate();
            return { year: y, month: m, day: d };
        }
        return null;
    }
    static date2ObjectTime(date: Date) {
        if (date) {
            let h = date.getHours();
            let m = date.getMinutes();
            return { hours: h, minutes: m };
        }
        return null;
    }
    static Object2Date(obj: { year: any, month: any, day: any }, time: string = '') {
        var rv = null;
        if (obj.year && obj.month && obj.day) {
            rv = new Date(obj.year + '-' + obj.month + '-' + obj.day)
            rv = StringUtil.setDateTime(rv, time);
        }
        return rv;
    }
    static Object2Str(obj: { year: any, month: any, day: any }, time: string = '') {
        var rv = null;
        if (obj.year && obj.month && obj.day) {
            rv = obj.year + '-' + (('00' + obj.month).slice(-2)) + '-' + (('00' + obj.day).slice(-2));
            if (time != '') {
                rv = rv + ' ' + time + ':00';
            }
        }
        return rv;
    }
    static str2Date(str: string) {
        // str = yyyy-mm-dd
        return new Date(str);
    }
    static date2Str(date: Date) {
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        let d = date.getDate();
        let rv = y + '-' + (('00' + m).slice(-2)) + '-' + (('00' + d).slice(-2));
        return rv;
    }
    static setDateTime(date: Date, time: string) {
        // time = HH:mm or HH:mm:ss
        let t: any[] = time.split(':');
        if (t.length == 2) {
            date.setHours(t[0]);
            date.setMinutes(t[1]);
            date.setSeconds(0);
        } else if (t.length == 3) {
            date.setHours(t[0]);
            date.setMinutes(t[1]);
            date.setSeconds(t[2]);
        } else {
            date.setHours(0);
            date.setMinutes(0);
            date.setSeconds(0);
        }
        return date;
    }
}